import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
/**
 * @author Saki
 * @date 2019-06-06 19:54:44
 * @Last Modified by: Saki
 * @Last Modified time: 2019-09-02 08:12:45
 */

import React, { Component } from 'react'; // we import scheduler.umd for IE11 compatibility only. If you don't use IE import:
// import { Scheduler, ObjectHelper } from 'bryntum-scheduler';

import { Scheduler, ObjectHelper } from 'bryntum-scheduler/scheduler.umd'; // Defines a React component that wraps Bryntum Scheduler

var BryntumScheduler =
/*#__PURE__*/
function (_Component) {
  _inherits(BryntumScheduler, _Component);

  var _super = _createSuper(BryntumScheduler);

  function BryntumScheduler() {
    var _this;

    _classCallCheck(this, BryntumScheduler);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.featureRe = /Feature$/;
    _this.features = ['cellEditFeature', 'cellTooltipFeature', 'columnDragToolbarFeature', 'columnLinesFeature', 'columnPickerFeature', 'columnReorderFeature', 'columnResizeFeature', 'contextMenuFeature', 'dependenciesFeature', 'dependencyEditFeature', 'eventContextMenuFeature', 'eventDragCreateFeature', 'eventDragFeature', 'eventEditFeature', 'eventFilterFeature', 'eventResizeFeature', 'eventTooltipFeature', 'filterBarFeature', 'filterFeature', 'groupFeature', 'groupSummaryFeature', 'headerContextMenuFeature', 'labelsFeature', 'nonWorkingTimeFeature', 'panFeature', 'quickFindFeature', 'regionResizeFeature', 'resourceTimeRangesFeature', 'rowReorderFeature', 'scheduleContextMenuFeature', 'scheduleTooltipFeature', 'searchFeature', 'sortFeature', 'stripeFeature', 'summaryFeature', 'timeRangesFeature', 'treeFeature'];
    _this.configs = ['assignments', 'assignmentStore', 'autoHeight', 'barMargin', 'columns', 'crudManager', 'dependencyStore', 'displayDateFormat', 'emptyText', 'endDate', 'eventBodyTemplate', 'eventColor', 'eventLayout', 'eventRenderer', 'events', 'eventStyle', 'eventStore', 'fillTicks', 'maxHeight', 'maxWidth', 'maxZoomLevel', 'milestoneAlign', 'minZoomLevel', 'height', 'minHeight', 'minWidth', 'partner', 'readOnly', 'resources', 'resourceStore', 'resourceTimeRanges', 'responsiveLevels', 'rowHeight', 'scrollLeft', 'scrollTop', 'selectedEvents', 'snap', 'startDate', 'tickWidth', 'timeRanges', 'timeResolution', 'viewportCenterDate', 'viewPreset', 'zoomLevel'];
    return _this;
  }

  _createClass(BryntumScheduler, [{
    key: "componentDidMount",
    value:
    /* #endregion */
    // React component rendered to DOM, render scheduler to it
    function componentDidMount() {
      var _this2 = this;

      var config = {
        appendTo: this.el,
        callOnFunctions: true,
        features: {}
      }; // relay properties with names matching this.featureRe to features

      this.features.forEach(function (featureName) {
        if (featureName in _this2.props) {
          config.features[featureName.replace(_this2.featureRe, '')] = _this2.props[featureName];
        }
      }); // Handle config (relaying all props except those used for features to scheduler)

      Object.keys(this.props).forEach(function (propName) {
        if (!propName.match(_this2.featureRe) && undefined !== _this2.props[propName]) {
          config[propName] = _this2.props[propName];
        }
      }); // console.log(config);
      // Create the actual scheduler, used as engine for the wrapper

      var engine = this.schedulerEngine = this.props.schedulerClass ? new this.props.schedulerClass(config) : new Scheduler(config); // Map all features from schedulerEngine to scheduler to simplify calls

      Object.keys(engine.features).forEach(function (key) {
        var featureName = key + 'Feature';

        if (!_this2[featureName]) {
          _this2[featureName] = engine.features[key];
        }
      });
    } // React component removed, destroy engine

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.schedulerEngine.destroy();
    } // Component about to be updated, from changing a prop using state. React to it depending on what changed and
    // prevent react from re-rendering our component.

  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _this3 = this;

      var engine = this.schedulerEngine,
          props = this.props,
          // These props are ignored or has special handling below
      excludeProps = ['adapter', 'children', 'columns', 'events', 'eventsVersion', 'listeners', // #9114 prevents the crash when listeners are changed at runtime
      'ref', 'resources', 'resourcesVersion', 'timeRanges'].concat(_toConsumableArray(this.features)); // Reflect configuration changes. Since most scheduler configs are reactive the scheduler will update automatically

      Object.keys(props).forEach(function (propName) {
        // Only apply if prop has changed
        if (!excludeProps.includes(propName) && !ObjectHelper.isEqual(props[propName], nextProps[propName])) {
          engine[propName] = nextProps[propName];
        }
      }); // xxVersion used to flag that data has changed

      if (nextProps.resourcesVersion !== props.resourcesVersion) {
        engine.resources = nextProps.resources;
      }

      if (nextProps.eventsVersion !== props.eventsVersion) {
        engine.eventStore.data = nextProps.events;
      } // Reflect feature config changes


      this.features.forEach(function (featureName) {
        var currentProp = props[featureName],
            nextProp = nextProps[featureName];

        if (featureName in props && !ObjectHelper.isEqual(currentProp, nextProp)) {
          engine.features[featureName.replace(_this3.featureRe, '')].setConfig(nextProp);
        }
      });
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: 'b-react-scheduler-container',
          ref: function ref(el) {
            return _this4.el = el;
          }
        })
      );
    } // eo function render

  }]);

  return BryntumScheduler;
}(Component); // eo class BryntumScheduler


BryntumScheduler.defaultProps = {
  viewPreset: 'hourAndDay',
  barMargin: 2
};
export default BryntumScheduler; // eof